import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let AlertComp;

class Alert extends Route {
    render(){
        return { outlet: '#zcatcomponent', component: AlertComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(
            import(/* webpackChunkName: "components/javascript/zcat-components/alert-comp" */
            "../../../components/javascript/zcat-components/alert-comp").then(function(res) {
                AlertComp = res.AlertComp;
            })
        );

        
;
    }
}

export {Alert};

